"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKey = void 0;

var React = __importStar(require("react"));

var use_event_1 = require("./use-event");

var createUseKeyPredicate = function createUseKeyPredicate(keyFilter) {
  return typeof keyFilter === 'function' ? keyFilter : typeof keyFilter === 'string' ? function (event) {
    return event.key === keyFilter;
  } : keyFilter ? function () {
    return true;
  } : function () {
    return false;
  };
};

function useKey(key, handler, options, deps) {
  if (options === void 0) {
    options = {};
  }

  if (deps === void 0) {
    deps = [key];
  }

  var _a = options.event,
      event = _a === void 0 ? 'keydown' : _a,
      target = options.target,
      opts = options.opts;
  var memoHander = React.useMemo(function () {
    var predicate = createUseKeyPredicate(key);
    return function (event) {
      if (predicate(event)) {
        return handler(event);
      }
    };
  }, [deps]);
  use_event_1.useEvent(event, memoHander, target, opts);
}

exports.useKey = useKey;